import { render, staticRenderFns } from "./PopupErrorView.vue?vue&type=template&id=ab0a1c42"
import script from "./PopupErrorView.vue?vue&type=script&lang=ts&setup=true"
export * from "./PopupErrorView.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./PopupErrorView.vue?vue&type=style&index=0&id=ab0a1c42&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports